// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"missedPaymentBanner_wrapper__3y2xD","textContent":"missedPaymentBanner_textContent__cz7xk","payButton":"missedPaymentBanner_payButton__NB8VG"};